import { Container } from "@/components/Container";
import { appLink } from "@/utils/links";
import { Button } from "@octolense/ui-components";

export function CallToAction() {
	return (
		<section id="get-started-today" className="relative overflow-hidden bg-white py-32">
			<Container className="relative">
				<div className="mx-auto max-w-lg text-center">
					<h2 className="font-display text-3xl tracking-tight text-black sm:text-4xl">
						Understand your Usage now!
					</h2>
					<p className="mt-4 text-lg tracking-tight text-black">
						It’s time to take control of your costs. Test it out for free on any individual GitHub
						account.
					</p>
					<Button as={"a"} href={appLink("/signin")} className="mt-10">
						Register Now
					</Button>
				</div>
			</Container>
		</section>
	);
}
